import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledCheckboxWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: ${tvar('space.x2')};
  }
`;

export const StyledCheckboxLabel = styled.label<{
  $color?: string;
  $visible: boolean;
}>`
  display: flex;
  align-items: center;
  font-weight: normal;
  cursor: pointer;

  &::before {
    /* visual checkbox */
    content: '';
    display: inline-block;
    width: 2.2rem;
    height: 2.2rem;
    margin-right: ${tvar('space.x1')};
    border: 0.15rem solid
      ${({ theme, $color }) => $color || theme.colors.typography.default};
    background: ${tvar('colors.fill.primary')};
  }
`;

export const StyledCheckboxLabelText = styled.span<{
  $visible?: boolean;
}>`
  ${({ $visible }) =>
    !$visible &&
    `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  `}
`;

export const StyledCheckbox = styled.input<{ $color?: string }>`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &:checked ~ label::before {
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14px' height='14px' viewBox='0 0 20 20' fill='none'%0A%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.8593 2L19 4.71355L6.22574 19L5.33767 18.239L5.17857 18.1023C5.07707 18.0149 4.93112 17.8891 4.75286 17.7348C4.39646 17.4263 3.91026 17.0034 3.39162 16.5466C2.37114 15.6477 1.17324 14.572 0.624488 13.9956L0 13.3396L2.92778 10.4727L6.05405 13.7167L15.8593 2Z' fill='${({
      theme,
      $color,
    }) =>
      encodeURIComponent(
        $color || theme.colors.typography.default,
      )}'%0A%3E%3C/path%3E%3C/svg%3E%0A");
  }
  &:disabled ~ label::before {
    background-color: ${tvar('colors.button.disabled.bg')};
    cursor: not-allowed;
  }
  &:focus ~ label {
    outline: 0.2rem solid;
  }
`;

export const StyledDescription = styled.p`
  width: 100%;
  font-weight: 300;
  font-size: 1.4rem;
  letter-spacing: 0.01em;
  display: block;
  margin-bottom: 0;
  margin-top: ${tvar('space.half')};
`;
